import { useUpdateSystemSettings } from '@/services/queries';
import { Card, CardContent, CardHeader } from '@/shared/ui/card';
import { Switch } from '@/shared/ui/switch';
import type { SystemSettings } from '@/types';

function SettingRow({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-6 border-t border-border py-4 first:border-t-0 first:pt-0 last:pb-0">
      <div className="space-y-0.5">
        <p className="text-[13.5px] font-semibold">{title}</p>
        <p className="text-[12.5px] text-muted-foreground">{description}</p>
      </div>
      {children}
    </div>
  );
}

export function NotificationsCard({ settings }: { settings: SystemSettings }) {
  const update = useUpdateSystemSettings();

  return (
    <Card>
      <CardHeader>
        <p className="text-[15px] font-semibold">Notifications</p>
        <p className="text-[12.5px] text-muted-foreground">Where NuDent sends operational alerts</p>
      </CardHeader>
      <CardContent className="pt-0">
        <SettingRow
          title="Daily expiry digest"
          description="08:00 UTC summary of licences expiring in 30 days, to every superadmin."
        >
          <Switch
            checked={settings.dailyExpiryDigestEnabled}
            disabled={update.isPending}
            onCheckedChange={(checked) => {
              update.mutate({ dailyExpiryDigestEnabled: checked });
            }}
          />
        </SettingRow>

        <SettingRow
          title="Alert on unactivated purchases"
          description="Daily reminder to every superadmin for the first 14 days after purchase with no activation."
        >
          <Switch
            checked={settings.unactivatedPurchaseAlertEnabled}
            disabled={update.isPending}
            onCheckedChange={(checked) => {
              update.mutate({ unactivatedPurchaseAlertEnabled: checked });
            }}
          />
        </SettingRow>
      </CardContent>
    </Card>
  );
}
